import React, { useState, useEffect, useRef } from 'react';
import PropTypes from "prop-types";
import styled from 'styled-components';
import { Link } from "react-router-dom";

import { Client } from '../../client';
import { getFromattedPreset } from '../../selectors/entities/filters';
import RubleLightIcon from '../icons/RubleLightIcon';

const placeholder = '/images/builder/placeholder.jpg';
const sampleShirtImage = '/images/builder/shirtCatalogSample.png'

const Image = styled.img`
  display: block;
  height: auto;
  width: 100%;
  object-fit: cover;
  border: 1px solid white;
  border-radius: 2.66px;

  @keyframes loaded {
    0% {
      opacity: 0.1;
    }
    100% {
      opacity: 1;
    }
  }

  &.loaded:not(.has-error) {
    animation: loaded 3s ease-in-out;
  }

  &.has-error {
    content: url(${placeholder});
  }

  @media (max-width: 768px) {
    border-radius: 0;
  }
`;

const ProductLazyCanvas = ({
    onChange,
    value,
    displayName,
    price,
    isNew,
    isSale,
    index,
    preset,
}) => {
    const [isVisible, setIsVIsible] = useState(false);

    const rootRef = useRef()

    useEffect(
        () => {
            let observer;
            if (IntersectionObserver) {
                observer = new IntersectionObserver(
                    entries => {
                        entries.forEach(entry => {
                            if (
                                (entry.intersectionRatio > 0 || entry.isIntersecting)
                            ) {
                                setTimeout(() => setIsVIsible(true), 100)
                                observer.unobserve(rootRef.current);
                            }
                        });
                    },
                    {
                        threshold: 0.01,
                        rootMargin: '100%'
                    }
                );
                observer.observe(rootRef.current);
            }
            return () => {
                if (observer && observer.unobserve) {
                    observer.unobserve(rootRef.current);
                }
            };
        },
        [rootRef]
    );

    const onChangeFabric = () => {
        onChange(value, index, preset);
    }

    const onImageError = (e) => {
        console.info(`%cmissing texture: ${e.target.src}`, 'color: blue; font-weight: bold;');
        e.target.src = sampleShirtImage;
        e.target.style.padding = '15px';
    }

    const isNewBool = String(isNew).toLowerCase() === 'true';
    const isSaleBool = String(isSale).toLowerCase() === 'true';
    const priceFormat = Number(price).toLocaleString();

    if(!isVisible) {
        return (
            <div ref={rootRef} className='b-rit-product-wrapper b-rit-product-wrapper_loading'/>
        );
    }

    return (
        <div
            ref={rootRef}
            className='b-rit-product-wrapper'
            onClick={onChangeFabric}
        >
            <Image
                className='b-rit-product-image'
                src={Client.getCatalogPresetsImageUrl(value.toLowerCase(), getFromattedPreset(preset), 'small')}
                onError={onImageError} />
            <div className='b-rit-product-label'>
                <div className='b-rit-product-label__name'>{displayName}</div>
                {isNewBool && <div className='b-rit-product-label__new'>NEW</div>}
                {isSaleBool && <div className='b-rit-product-label__sale'>SALE</div>}
            </div>
            <div className='b-rit-product-price'>
                {priceFormat}&#160;
                <RubleLightIcon size={9} color='currentColor'/>
            </div>
        </div>
    );
}

ProductLazyCanvas.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    price: PropTypes.any.isRequired,
    isNew: PropTypes.any.isRequired,
    isSale: PropTypes.any.isRequired,
    index: PropTypes.number.isRequired,
    preset: PropTypes.string.isRequired,
}

export default ProductLazyCanvas;